export default __webpack_public_path__ + "static/media/star wars imaeg.7a6380fa.webp";